import axios from "axios";
import store from "../store";
import VueCookies from 'vue-cookies'
import authorization from "@/components/webportals/authorization/authorization.js";
export default {
  checkRoleActive,
  checkRoleAccess,
  checkTaxid,
  checkRoleActiveMenu,
};

var defaultRole = [
  { role_name: "owner", role_id: 0 },
  { role_name: "etax-admin", role_id: 1 },
  { role_name: "etax-bd", role_id: 2 },
  { role_name: "etax-user", role_id: 3 },
  { role_name: "user", role_id: 3 }
];

function checkRoleActive(_roledata) {
  let role = _roledata;
  let activerole = { role_name: "etax-user", role_id: 3 };
  role.forEach(e => {
    let checkindex_role = defaultRole.findIndex(
      x => x.role_name === e.role_name
    );
    if (checkindex_role > -1) {
      if (defaultRole[checkindex_role]["role_id"] < activerole.role_id) {
        activerole = defaultRole[checkindex_role];
      }
    }
  });

  return activerole;
}

async function checkRoleAccess(param) {
  if (store.getters.menu.length < 1) {
    try {
      var path = param.name;
      var payload = {
        taxid: VueCookies.get('STID')
      };
      var dataEncode = await authorization.encodeData(payload);
      var auth = await authorization.gentoken(VueCookies.get('STID'));
      var headers = { Authorization: "Bearer " + auth };
      let result = await axios.post(
        process.env.API_MAIN + "/setting_menu/list",
        { data: dataEncode },
        { headers }
      );
      if (result.data.status == "OK") {
        var menu = result.data.message;
        console.log(menu);
        store.dispatch("setMenu", menu);
      } else {
        var menu = store.state.defaultMenu;
      }
      let resultData = setRoleAccess(menu, path);
      return new Promise(resolve => {
        resolve(resultData);
      });
    } catch (err) {
      let resultData = setRoleAccess(menu, path);
      return new Promise(resolve => {
        resolve(resultData);
      });
    }
  } else {
    var path = param.name;
    let resultData = setRoleAccess(store.getters.menu, path);
    return new Promise(resolve => {
      resolve(resultData);
    });
  }
  }

async function checkTaxid(param) {
  if (store.getters.menu.length < 1) {
    try {
      var path = param.name;
      var payload = {
        taxid: VueCookies.get('STID')
      };

      var dataEncode = await authorization.encodeData(payload);
      var auth = await authorization.gentoken(VueCookies.get('STID'));
      var headers = { Authorization: "Bearer " + auth };
      let result = await axios.post(
        process.env.API_MAIN + "/setting_menu/list",
        { data: dataEncode },
        { headers }
      );
      if (result.data.status == "OK") {
        var menu = result.data.message;
        store.dispatch("setMenu", menu);
      } else {
        var menu = store.state.defaultMenu;
      }
      console.log(menu,path);
      let resultData = setTaxidAccess(menu, path);
      return new Promise(resolve => {
        resolve(resultData);
      });
    } catch (err) {
      var menu = store.state.defaultMenu;
      let resultData = setTaxidAccess(menu, path);
      return new Promise(resolve => {
        resolve(resultData);
      });
    }
  } else {
    var path = param.name;
    let resultData = setTaxidAccess(store.getters.menu, path);
    return new Promise(resolve => {
      resolve(resultData);
    });
  }
}

function setRoleAccess(menu, path) {
  if(path != "webportal_sftp_dir" && path != "webportal_sftp" && path != "webportal_userManual") {
    for (var i of menu) {
      if (i.name == path) {
        return i.role_access;
      }
      for (var j of i.child) {
        if (j.name == path) {
          return j.role_access;
        }
        for (var k of j.list) {
          if (k.name == path) {
            return k.role_access;
          }
        }
      }
    } 
  }  else {
    // var index = menu.findIndex(function(val) {
    //   return val.name == "sftp"
    // });
    return ["owner", "etax-admin", "etax-user", "etax-bd", "user"];
  }
}
function setTaxidAccess(menu, path) {
  if(path != "webportal_sftp_dir" && path != "webportal_sftp" && path != "webportal_userManual") {
    for (var i of menu) {
      if (i.name == path) {
        if (
          i.taxid_access.includes(VueCookies.get('STID')) ||
          i.taxid_access.length < 1
        ) {
          return true;
        }
      }
      for (var j of i.child) {
        if (j.name == path) {
          if (
            j.taxid_access.includes(VueCookies.get('STID')) ||
            j.taxid_access.length < 1
          ) {
            return true;
          }
        }
        for (var k of j.list) {
          if (k.name == path) {
            if (
              k.taxid_access.includes(VueCookies.get('STID')) ||
              k.taxid_access.length < 1
            ) {
              return true;
            }
          }
        }
      }
    }
  }else {
    // var index = menu.findIndex(function(val) {
    //   return val.name == "sftp"
    // });
    // if(menu[index].taxid_access.includes(VueCookies.get('STID')) ||
    //   menu[index].taxid_access.length < 1) {
    //   }
    return true;
  }
}

function checkRoleActiveMenu(_roledata) {
  let role = _roledata;
  let activerole = { role_name: "etax-user", role_id: 3 };
  role.forEach(e => {
    let checkindex_role = defaultRole.findIndex(
      x => x.role_name === e.role_name
    );
    if (checkindex_role > -1) {
      if (defaultRole[checkindex_role]["role_id"] < activerole.role_id) {
        activerole = defaultRole[checkindex_role];
      }
    }
  });

  return activerole;
}





// WEBPACK FOOTER //
// ./src/functions/etaxrolelevel.js